import { StyledSocial } from '@/components/styles'
import Icon from '@/assets/icons'

export default function Social({ href, icon, ...props }) {
  return (
    <StyledSocial href={href} target="_blank" rel="noopener noreferrer" {...props}>
      <Icon name={icon} fill='currentColor'/>
    </StyledSocial>
  )
}
